import type { ModelId, ViewModelId, ClientSelectedItemJSON } from 'balus-common';
import { useSnapshot } from '@framework/hooks/useSnapshot';
import { RTDBPath } from 'balus-common';
import { clientSelectedItemCollectionAtomFamily } from './clientSelectedItemCollectionAtom';
import { ClientSelectedItem, ClientSelectedItemCollection } from '@model-framework/client-selected-item/domain';
import { useSetAtom } from 'jotai/react';
import { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { t } from 'i18next';

// ノードを選択しているユーザを取得してatomに読み込む
export function ClientSelectedItemCollectionLoader({
  viewModelId,
  modelId,
}: {
  viewModelId: ViewModelId;
  modelId: ModelId;
}) {
  const setState = useSetAtom(clientSelectedItemCollectionAtomFamily(modelId));

  useSnapshot({
    path: RTDBPath.ViewModelViewer.clientSelectedItemPath(viewModelId, modelId),
    load({ getChildValues }) {
      const values = Object.values(getChildValues() as Record<string, ClientSelectedItemJSON>);
      const selectedItems = values.map((item) => ClientSelectedItem.load(item));
      setState(new ClientSelectedItemCollection(selectedItems));
    },
    stateless: true,
    onError() {
      toast.error(t('common.message.loadFailed'));
    },
  });

  useEffect(() => {
    return () => {
      setState(null);
    };
  }, [setState]);

  return null;
}
